import React from "react";
import { Modal } from "@ts-digital/vrc";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { useSelector } from "react-redux";
import TSPayCollect from "../../../../assets/img/tspaycollect.svg";
import "./style.css";
import numeral from "numeral";

const TSPayShareDialog = props => {
  const { visibleDialog, onClose } = props;

  const infoDeadline = useSelector(state => state.deadlinesDetail.subjective);
  const tspay = useSelector(state => state.tspay);
  const [linkCopiato, setLinkCopiato] = useState(null);
  const [alertLabel, setAlertLabel] = useState("Copia link");
  const [colorLabel, setColorLabel] = useState("#152935");
  const [ , setMarginLabel] = useState("1px");

  let deadlineDesc =
    infoDeadline.description.title +
    " " +
    (infoDeadline.description.details ? infoDeadline.description.details : "");

  const copyToClipboard = () => {
    var textField = document.createElement("textarea");
    if (tspay.link.result) {
      textField.innerText = tspay.link.result.url;
      document.body.appendChild(textField);
      textField.select();
      document.execCommand("copy");
      textField.remove();
      setAlertLabel("Link copiato!");
      setLinkCopiato(true);
    } else {
      setAlertLabel("Attenzione: link non disponibile!");
      setColorLabel("#d82829");
      setMarginLabel("-50px");
    }
  };

  return (
    <React.Fragment>
      <Modal
        visible={visibleDialog}
        title="Richiedi pagamento con TS Pay"
        onClose={() => onClose()}
        type="primary"
      >
        <div className="dbx-tspay-collect-dialog-root">
          <div className="tspayCollectImage">
            <img src={TSPayCollect} alt="ts-pay-collection" />
          </div>
          <div className="shareFolderLinks shareTSPayLinks">
            <div width="100%">
              <div
                className="imageShare"
                style={{ marginTop: "35px", cursor: "pointer" }}
                onClick={() => copyToClipboard()}
              >
                <FontAwesomeIcon icon={["far", "link"]} className="shareIcon" />
              </div>
              {!linkCopiato ? (
                <div
                  style={{
                    height: "28px",
                    textAlign: "center",
                    color: colorLabel,
                    fontSize: "13px",
                    lineHeight: "2",
                    marginBottom: "30px"
                  }}
                >
                  {alertLabel}
                </div>
              ) : (
                <div
                  style={{
                    height: "28px",
                    position: "relative",
                    textAlign: "center",
                    color: "#0090d1",
                    fontSize: "12px",
                    lineHeight: "2",
                    marginBottom: "30px"
                  }}
                >
                  {alertLabel}
                </div>
              )}
            </div>
          </div>
          <div className="shareFolder">
            {!linkCopiato ? (
              <React.Fragment>
                Copia il link che puoi inviare per richiedere il pagamento di{" "}
                <b>{deadlineDesc} </b> con TS Pay
                <br />
                Importo:{" "}
                <b>{numeral(infoDeadline.totalAmount).format("0,0.00")} €</b>
              </React.Fragment>
            ) : (
              <React.Fragment>
                Incolla (ctrl+v) in un messaggio <b>Email</b> o di{" "}
                <b>messaggistica istantanea</b> (Whatsapp, Telegram, ecc) per
                richiedere il pagamento al tuo cliente.
              </React.Fragment>
            )}
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default TSPayShareDialog;
